import { Dispatch, SetStateAction, useEffect, useState } from 'react';
export interface PaginationProps {
    pageSize: number;
    pageStart: number;
}

export interface Pagination extends PaginationProps {
    setPagination: Dispatch<SetStateAction<PaginationProps>>;
    currentPage: number;
    setCurrentPage: Dispatch<SetStateAction<number>>;
}

export const usePagination = (initialPageSize?: number): Pagination => {
    const [{ pageSize, pageStart }, setPagination] = useState<PaginationProps>({
        pageSize: initialPageSize ?? 1000,
        pageStart: 0,
    });
    const [currentPage, setCurrentPage] = useState<number>(
        pageStart && pageSize ? Math.floor(pageStart / pageSize) + 1 : 1
    );

    useEffect(() => {
        setPagination({ pageStart: (currentPage - 1) * pageSize, pageSize: pageSize });
    }, [currentPage, pageSize]);

    return {
        pageSize,
        pageStart,
        setPagination,
        currentPage,
        setCurrentPage,
    };
};
